import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-white w-full h-full opacity-30 z-[100]" }, null, -1)
const _hoisted_2 = { class: "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" }

import AtomSpinner from "@/components/third-party/epic-spinners/AtomSpinner.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AtomSpinner, {
        "animation-duration": 1000,
        size: 5,
        color: "#0c97ad"
      })
    ])
  ]))
}
}

})